import { serviceInstance as api } from "../service";

export const getOrders = async (params) => {
  let queryParamsString;

  if (params.id_orden) {
    queryParamsString = new URLSearchParams({
      id_orden: params.id_orden,
    }).toString();
  } else if (params.fechaInicioPedido && params.fechaFinPedido) {
    queryParamsString = new URLSearchParams({
      fechaInicioPedido: params.fechaInicioPedido.replace(/-/g, ""),
      fechaFinPedido: params.fechaFinPedido.replace(/-/g, ""),
    }).toString();
  } else {
    // Should not happen if form validation is correct, but as a fallback:
    console.error("Error: Insufficient parameters for getOrders. Neither id_orden nor date range provided.");
    return []; // Or throw an error
  }

  const response = await api().get(
    `/orden${!!queryParamsString ? "?" + queryParamsString : ""}`
  );

  return response.data.result.data;
};

export async function getEventsByOrderId(query) {
  const queryParams = new URLSearchParams({
    id: query.id,
    posicion: query.posicion /*'749575-1-39' */,
  }).toString();

  const response = await api().get(
    `/orden/eventos${!!queryParams ? "?" + queryParams : ""}`
  );
  return response.data.result.data;
}

export async function updateOrder(payload) {
  const response = await api().put(
    `/orden`,
    payload
  );
  return response.data.result;
}

export async function createCall(payload) {
  const response = await api().post(
    `/evento/telemercadeo`,
    payload
  );
  return response.data.result;
}

export async function closeOcurrence(payload) {
  const response = await api().put(
    `/evento/novedad`,
    payload
  );
  return response.data.result;
}

export const getOcurrences = async (params) => {
  let queryParamsString;

  if (params.id_orden) {
    queryParamsString = new URLSearchParams({
      id_orden: params.id_orden,
    }).toString();
  } else if (params.fechaInicioPedido && params.fechaFinPedido) {
    queryParamsString = new URLSearchParams({
      fecha_creacion_min: params.fechaInicioPedido.replace(/-/g, ""),
      fecha_creacion_max: params.fechaFinPedido.replace(/-/g, ""),
    }).toString();
  } else {
    console.error("Error: Insufficient parameters for getOcurrences. Neither id_orden nor date range provided.");
    return [];
  }

  const response = await api().get(
    `/evento/novedad${!!queryParamsString ? "?" + queryParamsString : ""}`
  );

  return response.data.result.data;
};